/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionBidsDetails_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"useAuctionPricing_item">;
    readonly " $refType": "PdpSharedAuctionBidsDetails_item";
};
export type PdpSharedAuctionBidsDetails_item$data = PdpSharedAuctionBidsDetails_item;
export type PdpSharedAuctionBidsDetails_item$key = {
    readonly " $data"?: PdpSharedAuctionBidsDetails_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionBidsDetails_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionBidsDetails_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '7d7c6a6aa9ef81d0c3910a48b9297e25';
export default node;
